import type { ReactNode } from 'react'
import { Reveal } from './reveal'
import { cn } from '@/lib/utils'

type SectionHeadingProps = {
  eyebrow: string
  title: ReactNode
  description?: ReactNode
  className?: string
  id?: string
}

export function SectionHeading({ eyebrow, title, description, className, id }: SectionHeadingProps) {
  return (
    <Reveal className={cn('mb-12 max-w-2xl md:mb-16', className)}>
      <p className="eyebrow mb-4 flex items-center gap-3">
        <span className="h-px w-8 bg-gradient-to-r from-blush to-lilac" aria-hidden="true" />
        {eyebrow}
      </p>
      <h2 id={id} className="text-balance text-4xl font-medium tracking-tight text-white md:text-5xl">
        {title}
      </h2>
      {description && <p className="mt-5 text-pretty text-lg leading-relaxed text-zinc-400">{description}</p>}
    </Reveal>
  )
}
